/* eslint-disable vue/no-unused-vars */
<template>
  <div id="app">
    <el-container>
      <el-container>
        <!-- ── Vista de vídeo ── -->
        <div v-if="isViewingVideo" class="vplayer-wrapper">
          <!-- Topbar del player -->
          <div class="vplayer-topbar">
            <button class="detail-btn-back" @click="closeVideo">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <line
                  x1="19"
                  y1="12"
                  x2="5"
                  y2="12"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <polyline
                  points="12,19 5,12 12,5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  fill="none"
                />
              </svg>
              Volver
            </button>
            <div class="vplayer-topbar__info">
              <span class="vplayer-topbar__title">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 6px;
                  "
                >
                  <polygon points="23,7 16,12 23,17" fill="#0284C7" />
                  <rect
                    x="1"
                    y="5"
                    width="15"
                    height="14"
                    rx="2"
                    fill="#0284C7"
                  />
                </svg>
                Reproduciendo vídeo
              </span>
              <span class="vplayer-topbar__sub" v-if="order">
                #{{ order.id }} · {{ order[visibleOrderFields[1]] || "" }}
              </span>
            </div>
          </div>
          <!-- Área del vídeo -->
          <div class="vplayer-body">
            <div class="vplayer-stage">
              <video controls autoplay class="vplayer-video">
                <source :src="videoUrl" type="video/mp4" />
                Tu navegador no soporta el elemento de vídeo.
              </video>
            </div>
          </div>
        </div>

        <!-- ── Vista principal ── -->
        <el-main v-else class="jobs">
          <!-- ── Topbar de detalle ── -->
          <div class="detail-topbar" v-if="order">
            <div class="detail-topbar__left">
              <button class="detail-btn-back" @click="volver()">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                  <line
                    x1="19"
                    y1="12"
                    x2="5"
                    y2="12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <polyline
                    points="12,19 5,12 12,5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    fill="none"
                  />
                </svg>
                Volver
              </button>
            </div>
            <div class="detail-topbar__center">
              <h1 class="detail-topbar__title">{{ tField("orderData") }}</h1>
              <div class="detail-topbar__subtitle">
                #{{ order.id }} · {{ order[visibleOrderFields[1]] || "" }}
              </div>
            </div>
            <div class="detail-topbar__actions">
              <button
                v-if="hasAvailableVideos"
                class="detail-action-btn detail-action-btn--video"
                title="Generar vídeo"
                @click="generateVideo"
              >
                <!-- video camera icon -->
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <polygon points="23,7 16,12 23,17" fill="currentColor" />
                  <rect
                    x="1"
                    y="5"
                    width="15"
                    height="14"
                    rx="2"
                    fill="currentColor"
                  />
                </svg>
              </button>
              <template v-if="isAdmin">
                <router-link
                  :to="{
                    name: 'OrderUpdate',
                    params: { id: this.order.id },
                  }"
                >
                  <button
                    class="detail-action-btn detail-action-btn--edit"
                    title="Editar"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </router-link>
                <button
                  class="detail-action-btn detail-action-btn--delete"
                  title="Eliminar"
                  @click="deleteOrder"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <polyline
                      points="3,6 5,6 21,6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M19 6l-1 14H6L5 6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M10 11v6M14 11v6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M9 6V4h6v2"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </button>
              </template>
            </div>
          </div>

          <!-- ── Contenido principal (scroll) ── -->
          <div class="detail-body">
            <!-- ── Fields grid ── -->
            <div class="detail-fields-card" v-if="order">
              <div class="detail-fields-grid">
                <div
                  v-for="(field, i) in visibleOrderFields"
                  :key="field"
                  class="detail-field-cell"
                  :class="{ 'detail-field-cell--right': i % 2 !== 0 }"
                >
                  <div class="detail-field-label">
                    {{ field === "id" ? "ID" : tField(field) }}
                  </div>
                  <div class="detail-field-value">
                    {{ formatField(order[field], field) }}
                  </div>
                </div>
                <!-- Status cell -->
                <div class="detail-field-cell detail-field-cell--right">
                  <div class="detail-field-label">{{ tField("status") }}</div>
                  <div class="detail-field-value">
                    <span
                      v-if="order.status == 'Created'"
                      class="detail-badge detail-badge--warning"
                    >
                      <span class="detail-badge__dot"></span>{{ order.status }}
                    </span>
                    <span
                      v-if="order.status == 'Pending'"
                      class="detail-badge detail-badge--warning"
                    >
                      <span class="detail-badge__dot"></span>{{ order.status }}
                    </span>
                    <span
                      v-if="order.status == 'Failed'"
                      class="detail-badge detail-badge--error"
                    >
                      <span class="detail-badge__dot"></span>{{ order.status }}
                    </span>
                    <span
                      v-if="order.status == 'Completed'"
                      class="detail-badge detail-badge--success"
                    >
                      <span class="detail-badge__dot"></span>{{ order.status }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- ── Clips card ── -->
            <div class="detail-clips-card">
              <div class="detail-clips-header">
                <span class="detail-clips-title">Clips de vídeo</span>
                <span class="detail-clips-count"
                  >{{ videos.length }} clips</span
                >
              </div>

              <el-table
                :key="cambia"
                class="videos-report"
                :data="videos"
                fit
                header-row-class-name="draggable"
                v-loading="loading"
                :row-class-name="tableRowClassName"
                :empty-text="$t('main.jobs.noVideos')"
                style="width: 100%"
              >
                <slot name="jobs">
                  <el-table-column
                    :min-width="30"
                    label="#"
                    prop="id"
                    align="center"
                    class-name="video-report-cell"
                  >
                  </el-table-column>

                  <el-table-column
                    :min-width="120"
                    :label="tField('recorderName')"
                    sortable
                    prop="recorderName"
                    align="center"
                    class-name="video-report-cell"
                  >
                  </el-table-column>

                  <el-table-column
                    :min-width="90"
                    :label="tField('origin')"
                    sortable
                    prop="origin"
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.isSeparator"></span>
                      <span v-else>
                        {{
                          scope.row.integrity === 1
                            ? "Grabador"
                            : scope.row.integrity === 2
                            ? "Sin subir"
                            : "Perdido"
                        }}
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="90"
                    :label="tField('status')"
                    sortable
                    prop="integrity"
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template #default="{ row }">
                      <span v-if="row.isSeparator"></span>
                      <el-tooltip
                        v-else-if="row.integrity === 1"
                        effect="dark"
                        placement="top-start"
                        content="Vídeo disponible"
                      >
                        <span class="clip-status-ok">✓</span>
                      </el-tooltip>
                      <el-tooltip
                        v-else
                        effect="dark"
                        placement="top-start"
                        content="Vídeo no disponible"
                      >
                        <span class="clip-status-ko">✕</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="120"
                    label="URL"
                    sortable
                    prop="url"
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template #default="{ row }">
                      <span class="clip-url">{{ row.url }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="90"
                    :label="tField('videoStart')"
                    sortable
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template #default="{ row }">
                      <span class="clip-time">{{
                        formatTime(row.videoStart)
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="90"
                    :label="tField('videoEnd')"
                    sortable
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template #default="{ row }">
                      <span class="clip-time">{{
                        formatTime(row.videoEnd)
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="90"
                    :label="tField('uploadedAt')"
                    sortable
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template #default="{ row }">
                      {{ formatUploadDate(row.uploadedAt, row.integrity) }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    :min-width="90"
                    :label="tField('warning')"
                    sortable
                    prop="falta"
                    align="center"
                    class-name="video-report-cell"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        v-if="scope.row.falta == '❌'"
                        effect="dark"
                        placement="top-start"
                        content="Falta video"
                      >
                        <span>{{ scope.row.falta }}</span>
                      </el-tooltip>

                      <el-tooltip
                        v-if="scope.row.falta == '✔️'"
                        effect="dark"
                        placement="top-start"
                        content="Video Correcto"
                      >
                        <span>{{ scope.row.falta }}</span>
                      </el-tooltip>

                      <el-tooltip
                        v-if="scope.row.falta == '⚠️'"
                        effect="dark"
                        placement="top-start"
                        content="Video con Solapamiento"
                      >
                        <span>{{ scope.row.falta }}</span>
                      </el-tooltip>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label=""
                    :min-width="160"
                    align="center"
                    class-name="video-report-cell-actions"
                  >
                    <template slot-scope="scope">
                      <div class="clip-row-actions">
                        <button
                          v-if="isAdmin"
                          class="clip-action-btn clip-action-btn--delete"
                          @click="confirmDelete(scope.row)"
                          title="Borrar Video"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <polyline
                              points="3,6 5,6 21,6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                            <path
                              d="M19 6l-1 14H6L5 6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                            <path
                              d="M10 11v6M14 11v6"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                            <path
                              d="M9 6V4h6v2"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </svg>
                          Borrar
                        </button>
                        <button
                          v-if="scope.row.integrity == 1"
                          class="clip-action-btn clip-action-btn--view"
                          @click="viewVideo(scope.row)"
                          title="Ver Video"
                        >
                          <svg
                            width="13"
                            height="13"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <polygon
                              points="23,7 16,12 23,17"
                              fill="currentColor"
                            />
                            <rect
                              x="1"
                              y="5"
                              width="15"
                              height="14"
                              rx="2"
                              fill="currentColor"
                            />
                          </svg>
                          Ver
                        </button>
                      </div>
                    </template>
                  </el-table-column>
                </slot>
              </el-table>
            </div>
          </div>
          <!-- /detail-body -->
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import ordersApi from "@/services/orders.api";
import moment from "moment";
import config from "@/../public/config.json";
import storage from "../utils/storage";
import { mapState } from "vuex";

export default {
  name: "OrderDetail",
  data: function () {
    return {
      videoUrl: "",
      isViewingVideo: false,
      size: "",
      API_URL: process.env.VUE_APP_API_URL,
      videos: [],
      loadingVideos: false,
      jobs: [
        {
          params: {
            videoStart: "",
            finishTime: "",
            recorderName: "",
          },
          titulos: {
            recorderName: "Carretilla",
            order: "Order",
          },
          attempts: {
            delay: 0,
          },
        },
      ],
      ordenacion: "descending",
      order: null,
      cambia: false,
      button: {
        text: "Ver Carga",
      },
      expedition: {
        id: 0,
      },
      completo: "false",
      input: "",
      value1: "",
      filters: {
        videoStart: new Date(),
      },
      posibleFilters: {},
      dialogVisible: false,
      loading: false,
    };
  },
  computed: {
    ...mapState("config", ["visibleFieldsDetail"]),
    isAdmin() {
      return sessionStorage.getItem("role") === "admin";
    },
    tField() {
      return (key) => this.$t(`main.jobs.fields.${key}`);
    },
    tButton() {
      return (key) => this.$t(`main.jobs.buttons.${key}`);
    },
    tConfirm() {
      return (key) => this.$t(`main.jobs.${key}`);
    },
    orderFields() {
      return [
        "id",
        ...(Array.isArray(config.mainAttributes) ? config.mainAttributes : []),
        ...(Array.isArray(config.additionalAttributes)
          ? config.additionalAttributes
          : []),
      ];
    },
    visibleOrderFields() {
      const fields = Array.isArray(this.visibleFieldsDetail)
        ? this.visibleFieldsDetail
        : [];
      const allFields = ["id", ...fields];
      return allFields.filter((field) => field !== "recorderId");
    },
    hasAvailableVideos() {
      return this.videos.some((video) => video.integrity === 1);
    },
  },
  async created() {
    try {
      const response = await ordersApi.fetchById(this.$route.params.id);
      this.order = response.data;
      await this.fetchOrderVideos(this.order);
    } catch (err) {
      console.error("Error fetching order: ", err);
    }
  },
  methods: {
    formatField(value, fieldName) {
      if (fieldName === "videoStart" || fieldName === "videoEnd") {
        return moment(value).format("DD/MM/YYYY - HH:mm:ss");
      }
      if (fieldName === "createdAt") {
        return moment(value).format("DD/MM/YYYY");
      }
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      const dateFields = ["createdAt", "updatedAt", "videoStart", "videoEnd"];
      if (dateFields.includes(fieldName)) {
        if (
          value instanceof Date ||
          moment(value, moment.ISO_8601, true).isValid()
        ) {
          return moment(value).format("HH:mm:ss");
        }
      }
      return value == null ? "" : String(value);
    },
    viewVideo(row) {
      let filePath = row.url.replace(/^\/+/, "");
      filePath = filePath
        .split("/")
        .map((segment) => encodeURIComponent(segment))
        .join("/");
      const isSwRegistered = storage.loadSwStatus();
      if (isSwRegistered === "true") {
        this.videoUrl = `${this.API_URL}/videos/url/${filePath}`;
      } else {
        const token = storage.loadToken();
        this.videoUrl = `${this.API_URL}/videos/url/token/${filePath}?token=${token}`;
      }
      this.$nextTick(() => {
        const player = this.$el.querySelector("video");
        if (player) player.scrollIntoView({ behavior: "smooth" });
      });
      this.isViewingVideo = true;
    },
    confirmDelete(row) {
      this.$confirm(
        this.$t("main.jobs.messages.confirmDeleteVideo") ||
          "¿Estás seguro de que deseas borrar este video?",
        this.$t("main.jobs.messages.confirmTitle") || "Confirmar eliminación",
        {
          confirmButtonText: this.$t("main.jobs.buttons.confirm") || "Sí",
          cancelButtonText: this.$t("main.jobs.buttons.cancel") || "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          this.deleteVideo(row);
        })
        .catch(() => {
          this.$message.info(
            this.$t("main.jobs.messages.deleteVideoCancelled") ||
              "Eliminación cancelada"
          );
        });
    },
    closeVideo() {
      this.isViewingVideo = false;
      this.videoUrl = "";
    },
    formatUploadDate(dateValue, integrity = 1) {
      if (integrity !== 1) return "-";
      if (!dateValue) return "";
      const m =
        typeof dateValue === "string" ? moment(dateValue) : moment(dateValue);
      return m.isValid() ? m.format("DD/MM/YY HH:mm:ss") : "";
    },
    async fetchOrderVideos(order) {
      if (!order) return;
      this.loadingVideos = true;
      try {
        const resp = await ordersApi.fetchVideosByOrder(order);
        if (
          Array.isArray(resp.data) &&
          resp.data.length > 0 &&
          Array.isArray(resp.data[0])
        ) {
          this.videos = [];
          resp.data.forEach((group, groupIndex) => {
            this.videos.push(...group);
            if (groupIndex < resp.data.length - 1) {
              const lastVideoOfGroup = group[group.length - 1];
              const firstVideoOfNextGroup = resp.data[groupIndex + 1][0];
              const endTime = this.formatTime(lastVideoOfGroup.videoEnd);
              const startTime = this.formatTime(
                firstVideoOfNextGroup.videoStart
              );
              this.videos.push({
                id: ``,
                isSeparator: true,
                recorderName: "",
                origin: "",
                integrity: -1,
                url: `PAUSA\n${endTime} → ${startTime}`,
                videoStart: null,
                videoEnd: null,
                uploadedAt: null,
                falta: "",
              });
            }
          });
        } else {
          this.videos = resp.data;
        }
      } catch (error) {
        console.error("Error fetching videos for order:", error);
      } finally {
        this.loadingVideos = false;
      }
    },
    formatTime(dateValue) {
      if (!dateValue) return "";
      const m =
        typeof dateValue === "string" ? moment(dateValue) : moment(dateValue);
      return m.isValid() ? m.format("HH:mm:ss") : "";
    },
    formatDate(dateString) {
      return dateString
        ? moment(dateString).local().format("DD/MM/YYYY HH:mm:ss")
        : "";
    },
    volver() {
      this.$router.push("/orders");
    },
    tableRowClassName({ row }) {
      if (row.isSeparator) {
        return "separator-row";
      }
      if (row.falta === "⚠️") {
        return "warning-row";
      }
      return row.integrity === 1 ? "row-integrity-1" : "row-integrity-0";
    },
    onOrderOpen() {
      let order = this.jobs[0].params;

      this.$router.push({
        name: "VideoPlayerView",
        params: { id: order.id },
      });
    },
    format() {
      return this.jobs[0].attempts.remaining;
    },
    async comprobanteFechas() {
      let videos = this.videos;
      let i = 0;
      for (i; i < videos.length - 1; i++) {
        if (videos[i].origin == "LOST") {
          let tiempo = videos[i + 1].videoStart;
          videos[i].finish_time = tiempo;
        }
        videos[i].indice = i + 1;
      }

      if (videos[videos.length - 1].origin == "LOST") {
        videos[videos.length - 1].finish_time = moment(
          this.jobs[0].params.finishTime
        )
          .local()
          .format("YYYY-MM-DD HH:mm:ss");
      }
      videos[videos.length - 1].indice = videos.length;
      await this.cambiaFecha();
    },
    async cambiaFecha() {
      let videos = this.videos;
      let i = 0;
      for (i; i < videos.length; i++) {
        let horaInicio = moment(videos[i].videoStart)
          .local()
          .format("HH:mm:ss");
        let horaFin = moment(videos[i].finish_time).local().format("HH:mm:ss");

        this.$set(this.videos[i], "horaInicio", horaInicio);
        this.$set(this.videos[i], "horaFin", horaFin);
      }
      console.log(videos);
    },
    async deleteVideo(row) {
      try {
        await ordersApi.deleteVideoById(row.uuid);
        this.$message.success(
          this.$t("main.jobs.videoDeleted") || "Video eliminado correctamente"
        );
        await this.fetchOrderVideos(this.order);
      } catch (error) {
        console.error("Error al eliminar el video:", error);
        if (error.response?.status === 403) {
          this.$message.error(
            this.$t("main.jobs.messages.noPermission") ||
              "No tienes permiso para eliminar este video"
          );
        } else if (error.response?.status === 404) {
          this.$message.error(
            this.$t("main.jobs.messages.videoNotFound") || "El video no existe"
          );
        } else {
          this.$message.error(
            this.$t("main.jobs.messages.deleteVideoError") ||
              "Error al eliminar el video"
          );
        }
      }
    },
    deleteOrder() {
      const isGroupOrder = this.order.groupId != null;
      const confirmMessage = isGroupOrder
        ? this.$t("main.jobs.messages.confirmDeleteGroupOrder") ||
          "¿Estás seguro de que deseas eliminar esta orden grupal? Se eliminarán todas las órdenes asociadas."
        : this.$t("main.jobs.messages.confirmDeleteOrder") ||
          "¿Estás seguro de que deseas eliminar esta orden?";
      this.$confirm(confirmMessage, {
        confirmButtonText: this.$t("main.jobs.buttons.confirm"),
        cancelButtonText: this.$t("main.jobs.buttons.cancel"),
        type: "warning",
      })
        .then(async () => {
          try {
            const id = this.order.id;
            await ordersApi.deleteById(id);
            const successMessage = isGroupOrder
              ? this.$t("main.jobs.messages.groupOrderDeleted") ||
                "Orden grupal eliminada correctamente"
              : this.$t("main.jobs.messages.orderDeleted") ||
                "Orden eliminada correctamente";
            this.$message.success(successMessage);
            this.volver();
          } catch (err) {
            console.error("Error eliminando orden:", err);
            if (err.response?.status === 403) {
              const errorMessage = isGroupOrder
                ? this.$t("main.jobs.messages.noPermissionGroupOrder") ||
                  "No tienes permiso para eliminar órdenes grupales"
                : this.$t("main.jobs.messages.noPermission") ||
                  "No tienes permiso para eliminar esta orden";
              this.$message.error(errorMessage);
            } else if (err.response?.status === 404) {
              this.$message.error(this.$t("main.jobs.messages.orderNotFound"));
            } else {
              const errorMessage = isGroupOrder
                ? this.$t("main.jobs.messages.deleteGroupOrderError") ||
                  "Error al eliminar la orden grupal"
                : this.$t("main.jobs.messages.deleteError") ||
                  "Error al eliminar la orden";
              this.$message.error(errorMessage);
            }
          }
        })
        .catch(() => {
          this.$message.info(this.$t("main.jobs.messages.deleteCancelled"));
        });
    },
    async generateVideo() {
      this.$confirm(
        this.$t("main.jobs.messages.confirmGenerateVideo") ||
          "¿Deseas generar el vídeo?",
        {
          confirmButtonText: this.$t("main.jobs.buttons.confirm") || "Sí",
          cancelButtonText: this.$t("main.jobs.buttons.cancel") || "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const id = this.order.id;
            await ordersApi.generateVideo(id);
            this.$message.success(
              this.$t("main.jobs.messages.videoGenerationStarted") ||
                "Generación de vídeo iniciada"
            );
          } catch (err) {
            console.error("Error generando video:", err);
            if (err.response?.status === 403) {
              this.$message.error(
                this.$t("main.jobs.messages.noPermission") ||
                  "No tienes permiso para generar el vídeo"
              );
            } else if (err.response?.status === 404) {
              this.$message.error(
                this.$t("main.jobs.messages.orderNotFound") ||
                  "No se encontró la orden"
              );
            } else {
              this.$message.error(
                this.$t("main.jobs.messages.generateError") ||
                  "Error al iniciar la generación del vídeo"
              );
            }
          }
        })
        .catch(() => {
          this.$message.info(
            this.$t("main.jobs.messages.generateCancelled") ||
              "Generación cancelada"
          );
        });
    },
    abrirNuevoTab: function (url) {
      // Abrir nuevo tab
      var http = new XMLHttpRequest();
      http.open("HEAD", url, false);
      http.send();
      if (http.status != 404) {
        var win = window.open(url, "_blank");
        // Cambiar el foco al nuevo tab (punto opcional)
        win.focus();
      } else if (http.status != 401) {
        this.$notify({
          title: "Atención!",
          message: "Atención el tiempo de la sesión se ha terminado",
          type: "warning",
        });
      } else {
        this.$notify({
          title: "Atención!",
          message: "Lo sentimos no tenemos ese video disponible",
          type: "warning",
        });
      }
    },

    getOriginTranslation(origin) {
      const translationKey = "main.videos." + origin;
      return this.$t(translationKey);
    },
  },
};
</script>

<style>
/* ── Layout ───────────────────────────────────────────────────── */
.jobs.el-main {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* ── Topbar ───────────────────────────────────────────────────── */
.detail-topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
  padding: 13px 22px;
  flex-shrink: 0;
}

.detail-topbar__left {
  flex-shrink: 0;
}

.detail-topbar__center {
  flex: 1;
}

.detail-topbar__title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.detail-topbar__subtitle {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
}

.detail-topbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Back button */
.detail-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 6px 12px;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
  font-family: inherit;
  transition: border-color 0.15s, color 0.15s;
}
.detail-btn-back:hover {
  border-color: #0284c7;
  color: #0284c7;
}

/* Icon action buttons */
.detail-action-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.15s, transform 0.15s;
  flex-shrink: 0;
}
.detail-action-btn:hover {
  opacity: 0.8;
  transform: translateY(-1px);
}
.detail-action-btn--delete {
  border-color: #fca5a5;
  background: #fef2f2;
  color: #ef4444;
}
.detail-action-btn--edit {
  border-color: #86efac;
  background: #f0fdf4;
  color: #16a34a;
}
.detail-action-btn--video {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #0284c7;
}

/* ── Scrollable body ──────────────────────────────────────────── */
.detail-body {
  flex: 1;
  overflow: auto;
  padding: 20px 22px;
}

/* ── Fields card ─────────────────────────────────────────────── */
.detail-fields-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  margin-bottom: 20px;
}

.detail-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.detail-field-cell {
  padding: 13px 18px;
  border-bottom: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
}
.detail-field-cell--right {
  border-right: none;
}

.detail-field-label {
  color: #0284c7;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 3px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.detail-field-value {
  color: #0f172a;
  font-size: 14px;
}

/* Status badges */
.detail-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.detail-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.detail-badge--success {
  background: #dcfce7;
  color: #15803d;
}
.detail-badge--success .detail-badge__dot {
  background: #22c55e;
}
.detail-badge--warning {
  background: #fef3c7;
  color: #b45309;
}
.detail-badge--warning .detail-badge__dot {
  background: #f59e0b;
  animation: pulseDot 1.5s ease infinite;
}
.detail-badge--error {
  background: #fee2e2;
  color: #b91c1c;
}
.detail-badge--error .detail-badge__dot {
  background: #ef4444;
}

@keyframes pulseDot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

/* ── Clips card ──────────────────────────────────────────────── */
.detail-clips-card {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.detail-clips-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e2e8f0;
}

.detail-clips-title {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.detail-clips-count {
  font-size: 12px;
  color: #64748b;
}

/* ── Table tweaks ────────────────────────────────────────────── */
.videos-report {
  padding: 0;
}

/* Unificar tipografía de todas las celdas de la tabla de clips */
.videos-report .el-table__cell .cell {
  font-size: 12px !important;
  color: #0f172a !important;
}

/* Caret en línea con el label — igual que en TableFiltrable */
.videos-report th.el-table__cell .cell {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  padding-left: 5px !important;
  padding-right: 0 !important;
  box-sizing: border-box;
  white-space: nowrap;
}

.videos-report th .caret-wrapper {
  display: inline-flex !important;
  flex-shrink: 0;
}

/* Row colours — mantiene lógica original */
.el-table .warning-row {
  background-color: #fff9c4 !important;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-table .alert-row {
  background: rgb(255, 182, 182);
}
.row-integrity-1 {
  background-color: #e6ffed !important;
}
.row-integrity-0 {
  background-color: #ffe6e6 !important;
}
.el-table .separator-row {
  background: #f5f7fa !important;
  border-top: 2px solid #dcdfe6;
  border-bottom: 2px solid #dcdfe6;
  font-weight: 600;
  color: #c0c4cc;
  text-align: center;
  pointer-events: none;
}
.el-table .separator-row:hover {
  background: #f5f7fa !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(0, 0, 0, 0) !important;
}
.el-table__cell .cell {
  text-overflow: clip;
}
.el-table .video-report-cell-actions .cell {
  text-overflow: clip;
}

/* Clip cell styles */
.clip-status-ok {
  color: #16a34a;
  font-size: 16px;
  font-weight: 700;
}
.clip-status-ko {
  color: #dc2626;
  font-size: 16px;
  font-weight: 700;
}
.clip-url {
  color: #0f172a;
  font-size: 12px;
  white-space: pre-line;
}
.clip-time {
  color: #0f172a;
  font-size: 12px;
}

/* ── Inline row action buttons ───────────────────────────────── */
.clip-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.clip-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  transition: opacity 0.15s, transform 0.15s;
  white-space: nowrap;
}
.clip-action-btn:hover {
  opacity: 0.82;
}
.clip-action-btn--delete {
  border-color: #fca5a5;
  background: #fef2f2;
  color: #ef4444;
}
.clip-action-btn--view {
  border-color: #86efac;
  background: #f0fdf4;
  color: #16a34a;
}
/* ── Video player view ───────────────────────────────────────── */
.vplayer-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #0d1117;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.vplayer-topbar {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #161b22;
  border-bottom: 1px solid #21262d;
  padding: 11px 20px;
  flex-shrink: 0;
}

.vplayer-topbar .detail-btn-back {
  background: #21262d;
  border-color: #30363d;
  color: #7d8590;
}
.vplayer-topbar .detail-btn-back:hover {
  border-color: #38bdf8;
  color: #38bdf8;
}

.vplayer-topbar__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.vplayer-topbar__title {
  color: #e6edf3;
  font-size: 15px;
  font-weight: 700;
}

.vplayer-topbar__sub {
  color: #7d8590;
  font-size: 11px;
}

.vplayer-body {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 40px;
  overflow: auto;
}

.vplayer-stage {
  width: 100%;
  max-width: 1100px;
  background: #000;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.7);
  border: 1px solid #21262d;
}

.vplayer-video {
  width: 100%;
  display: block;
  max-height: 70vh;
  background: #000;
}
</style>
